import { render } from "./ProfilePage-Form.vue?vue&type=template&id=7b08966e&scoped=true"
import script from "./ProfilePage-Form.vue?vue&type=script&lang=js"
export * from "./ProfilePage-Form.vue?vue&type=script&lang=js"

import "./ProfilePage-Form.vue?vue&type=style&index=0&id=7b08966e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b08966e"]])

export default __exports__